export class SaleModel {
    constructor(item) {
        for(let property in item) {
            if(property == 'my_like') {
                this[property] = ko.observable(item[property]);
            } else {
                this[property] = item[property];
            }
        }

        this.active = this.status == 'Активна';
        this.totalLikes = ko.observable(parseInt(this.likes_initial) + parseInt(this.likes));
        this.isTextBanner = this.banner_type == 'text';
        this.isImageBanner = this.banner_type == 'image';
    }

    saveLike(model, event, userId = null) {
        if (USER_ID || userId) {
            $.post(
                base_url + 'blog/likes_save',
                {id: this.page_id},
                (response) => {
                    if (response.success) {
                        if (response.action == 'up') {
                            this.my_like(true);
                        } else {
                            this.my_like(false);
                        }

                        this.totalLikes(response.likes);
                    }
                },
                'json'
            );
        }
        else {
            zde.showLogin((data) => {
                if(data) {
                    this.saveLike(model, event, data.id);
                    return;
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./modules/blog/common/model/salemodel.js